<div class="dup-lead-dialog">
  <div class="dialog-accent-bar"></div>

  <div class="dialog-body">
    <div class="dialog-header">
      <mat-icon class="header-icon">people_outline</mat-icon>
      <h2 mat-dialog-title>Duplicates Found</h2>
    </div>

    <p class="dialog-message">
      We found {{ items.length }} existing lead{{ items.length > 1 ? 's' : '' }} that may match. Would you like to save as new or review and merge?
    </p>

    @if (items?.length) {
      <div class="lead-cards">
        @for (lead of items; track lead._id) {
          <div class="lead-card">
            <div class="lead-avatar">{{ getInitials(lead) }}</div>
            <div class="lead-info">
              <span class="lead-name">{{ getFullName(lead) }}</span>
              @if (lead.profession) {
                <span class="lead-detail">
                  <mat-icon>work_outline</mat-icon>
                  {{ lead.profession }}
                </span>
              }
              @if (getLocation(lead)) {
                <span class="lead-detail">
                  <mat-icon>location_on</mat-icon>
                  {{ getLocation(lead) }}
                </span>
              }
              @if (getPhone(lead)) {
                <span class="lead-detail">
                  <mat-icon>phone</mat-icon>
                  {{ getPhone(lead) }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    }

    <mat-dialog-actions>
      <button mat-stroked-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="confirmCreate(false)">Save as New</button>
      <button mat-raised-button color="accent" (click)="confirmCreate(true)">Review &amp; Merge</button>
    </mat-dialog-actions>
  </div>
</div>